import React from "react";
import { OrderTabs } from "../state/OrderParentReducer";
import { OrderListFinishAllButton } from "../OrderList/OrderListFinishAllButton";
import { IProcessedOrders } from "../constants";
import { BacklogButton } from "./BacklogButton";
import { OrderKeys } from "../OrderParentContainer";

interface IFinishAllOrderButtonProps {
    selectedTab: string;
    orderList: IProcessedOrders[];
    orderKey: OrderKeys;
    isPickupNow: boolean;
}

export function OrderButtons({
    selectedTab,
    orderList,
    orderKey,
    isPickupNow
}: IFinishAllOrderButtonProps) {
    if (orderKey === "openedOrders") {
        if (selectedTab === OrderTabs.DELIVERY || selectedTab === OrderTabs.DINE_IN ||
            (selectedTab === OrderTabs.COLLECTION && !isPickupNow)) {
            return <OrderListFinishAllButton
                orderList={orderList}  disabled={orderList.length===0}/>;
        }
    } else {
        if (selectedTab === OrderTabs.COLLECTION && isPickupNow) {
            return <BacklogButton />;
        }
    }
    return null;

}